import React, { } from 'react';
import { Row, Col, Label, Input, FormGroup } from 'reactstrap';
import uuid from 'react-uuid';

const LargeFarmView = ({ largeEnterpriseDetails, handleLMUSelectChange }) => {
    if (largeEnterpriseDetails != undefined) {
        if (largeEnterpriseDetails.isLargeEnterprise) {
            return (
                <>
                    <Row>
                        <Col sm="8">
                            <Label>This property is large - Select separate Land units to add items if required</Label>
                        </Col>
                        <Col sm="4">
                            <FormGroup>
                                {largeEnterpriseDetails.LMUList != undefined && largeEnterpriseDetails.LMUList != null &&
                                    <Input type="select" className="float-end" onChange={handleLMUSelectChange} name="selectedLMUId" id="selectedLMUId" value={largeEnterpriseDetails.selectedLMUId}>
                                        <option value={0} >Entire Farm</option>
                                        {largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU).map(Option =>
                                            <option key={uuid()} value={Option.id}>{Option.name}</option>
                                        )}
                                    </Input>
                                }
                            </FormGroup>
                        </Col>
                    </Row>
                    <br />
                </>
            )
        }
    }
}
export default LargeFarmView